// Init Rellax.js after all elements have fully loaded so that all heights of DOMs are calculated
(function ($, window) {

	let win = $(window),
		instantiated = 0,
		rellax;

	win.on("load", () => {

		// Execute on load
		checkWidth();

		// Refresh whenever window is resized.
		win.on('resize.rellax-resize', $.debounce(250, checkWidth));

	});

	function checkWidth() {

		if (win.outerWidth() < 'NALU__BOOTSTRAP__BREAKPOINT__NALU') {
			if (instantiated === 1) {
				rellax.destroy();
				instantiated = 0;
			}
		} else {
			if (instantiated === 0 && $('.rellax').length > 0) {
				rellax = new Rellax('.rellax', {
					speed: -5
				});
				instantiated = 1;
			}
		}
	}

}(jQuery, window));